import {remCalc} from '_themeUtils'

const editorialWidget = {
    Widget: {
        baseStyle: ({
            // backgroundColor,
            // textColor,
            // borderColor,
            // maxWidth,
            // maxWidthMobile,
            // ratio,
            // borderWidth,
            backgroundColorCollapsed,
            textColorCollapsed,
            borderColorCollapsed,
            borderRadius,
            borderWidthCollapsed,
        }: {
            // backgroundColor: string
            // textColor: string
            // borderColor: string
            // borderWidth: string
            // maxWidth: string
            // maxWidthMobile: string
            // ratio: string
            backgroundColorCollapsed: string
            textColorCollapsed: string
            borderColorCollapsed: string
            borderWidthCollapsed: string
            borderRadius: string
        }) => ({
            widgetWrapper: {
                position: 'fixed',
                left: `calc(24px + ${borderWidthCollapsed})`,
                bottom: `calc(24px + ${borderWidthCollapsed})`,
                bg: backgroundColorCollapsed,
                borderRadius: borderRadius,
                boxShadow: `0 0 0 ${borderWidthCollapsed} ${borderColorCollapsed}`,
                overflow: 'hidden',
                zIndex: 300,
                cursor: 'pointer',
            },
            widgetButton: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: remCalc(8),
                p: remCalc(8),
                overflow: 'visible',
            },
            widgetButtonIconWrapper: {
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            },
            widgetButtonIcon: {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
            },
            widgetButtonTextWrapper: {
                h: 'auto',
                w: 'auto',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                minWidth: 0,
            },
            widgetCollapsedText: {
                color: textColorCollapsed,
                fontWeight: 400,
                fontSize: {base: remCalc(12), md: remCalc(14)},
                lineHeight: 1.2,
                textAlign: 'left',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            // widgetTextWrapper: {
            //     position: 'absolute',
            //     bottom: 0,
            //     w: '100%',
            //     h: '50%',
            //     p: {base: `0 ${remCalc(10)}`, md: `0 ${remCalc(16)}`},
            //     display: 'flex',
            //     transition: 'opacity 0.12s',
            //     opacity: 0,
            //     visibility: 'hidden',
            // },
            // widgetText: {
            //     marginTop: 'auto',
            //     marginBottom: remCalc(16),
            //     color: textColor,
            //     fontWeight: 300,
            //     fontSize: {base: remCalc(11), md: remCalc(16)},
            // },
        }),
    },
}

export default editorialWidget
